module.exports = __webpack_public_path__ + "static/media/Title.6e0bacdb.png";